import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from 'assets/images/common/mail.svg'
import _imports_1 from 'assets/images/common/key.svg'
import _imports_2 from 'assets/images/promo/eye.svg'
import _imports_3 from 'assets/images/landing/gamblers.png'


const _withScopeId = n => (_pushScopeId("data-v-0cd58376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reg-form-wrapper" }
const _hoisted_2 = { class: "reg-form" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-heading" }
const _hoisted_5 = { class: "reg-form-label" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "input-area-icon input-area-icon-email"
}, null, -1))
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "input-area-error-message" }
const _hoisted_9 = { class: "reg-form-label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "input-area-icon input-area-icon-password"
}, null, -1))
const _hoisted_11 = ["type", "placeholder"]
const _hoisted_12 = { class: "input-area-error-message input-area-error-password" }
const _hoisted_13 = { class: "modern-form__two-block" }
const _hoisted_14 = { class: "reg-form-label" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "input-area-error-message" }
const _hoisted_17 = { class: "terms-block" }
const _hoisted_18 = ["data-checked"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "input-area-error-message" }
const _hoisted_21 = ["value", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "modern-form__text"
}
const _hoisted_23 = ["value", "onClick"]
const _hoisted_24 = { class: "modern-form__btn-span" }
const _hoisted_25 = { class: "reg-form-sign-in-block" }
const _hoisted_26 = ["href", "onClick"]
const _hoisted_27 = { class: "modern-terms-link" }
const _hoisted_28 = ["href", "onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "form-provider-img",
    src: _imports_3,
    alt: "askGamblers"
  })
], -1))

import {
  computed,
  defineProps,
  ref,
  watch,
  defineEmits,
} from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRegForm } from '@/composables/useRegForm';
import LoaderPromoPopup from '@/components/loaderPromoPopup.vue';
import useLoaderPopup from '@/composables/loaderPopupState';
import { generateAuthToken, registerPlayer } from '@/services/registerPalayer';
import { checkEmail } from '@/services/validateEmail';
import { PromoLoaderInterface } from '~/types/promoLoader.interface';
import { registrationErrorsParser } from '@/utils/registerErrorsParser';
import { useRoute } from 'vue-router';
import { useGtmPush } from '@/composables/gtm';


export default /*#__PURE__*/_defineComponent({
  props: {
    formTitle: null,
    formBtnText: null,
    formText: null,
    lang: null,
    cryptoOnly: null,
    preselectedCurrency: null,
    promoLoader: null,
    targetHost: null
  },
  emits: ["changeCurrency"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeCurrency', currency: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formTitle?: string;
  formBtnText?: string;
  formText?: string;
  lang: string;
  cryptoOnly: boolean | null;
  preselectedCurrency: string | null;
  promoLoader: PromoLoaderInterface;
  targetHost?: string;
}





const changeCurrency = (currency: string) => {
  emit('changeCurrency', currency);
};

const store = useStore();
const route = useRoute();
const { push } = useGtmPush();
const { form, errors, currencies, activeCurrencies, regForm } =
  useRegForm(props);
const { openPopup, closePopup } = useLoaderPopup();

watch(
  () => form.currency,
  (newCurrency) => {
    changeCurrency(newCurrency);
  },
  { immediate: true }
);

const isShowPassword = ref(false);

const redirectHost = computed(() => store.getters['systemHosts/redirectHost']);
const landingRedirectHost = computed((): string => {
  return props.targetHost ? props.targetHost : redirectHost.value;
});

/**
 * By default we get title of button from reg-form into strapi
 * but it can be specifiyed by custom text from Props()
 */
const registerTitle = computed((): string => {
  return props.formBtnText || regForm.value.register_button_title;
});

/**
 * By default we get heder of form from reg-form into strapi
 * but it can be specifiyed by custom text from Props()
 */
const formHeaderTitle = computed((): string => {
  return props.formTitle || regForm.value.header;
});

const termsLink = computed(() => {
  return `https://${landingRedirectHost.value}/terms-and-conditions`;
});

const signInLink = computed(() => {
  return `https://${landingRedirectHost.value}?login`;
});

/**
 * redirect to SignIn page of main site
 */
const signIn = async () => {
  push({
    vCategory: 'landing_form',
    vAction: 'log_in',
  });

  window.location.href = signInLink.value;
};

const isRegisterSuccess = ref(false);
const invalidEmail = ref('');

const register = async () => {
  const playerInfo = {
    email: form.email,
    password: form.password,
    password_confirmation: form.password,
    profile_attributes: {
      nickname: form.email.substring(0, 4) + '****',
      currency: form.currency,
      terms_acceptance: !!form.terms_acceptance,
    },
  };

  openPopup();

  let isEmailValid = true;
  // Disabling email checker for Magnetics emails

  if (!playerInfo.email.includes('magnetics.io')) {
    isEmailValid = await checkEmail(playerInfo.email);
  }

  if (isEmailValid) {
    push({
      vCategory: 'landing_form',
      vAction: 'email',
      vLabel: 'success',
    });
  } else {
    invalidEmail.value = 'Email does not exist';
    closePopup();
    push({
      vCategory: 'landing_form',
      vAction: 'email',
      vLabel: 'fail',
    });

    return false;
  }

  const ssHost = computed(() => store.getters['systemHosts/ssHost']);
  const registrationResult = await registerPlayer(
    playerInfo,
    ssHost.value,
    props.lang
  );

  if (registrationResult.errors) {
    closePopup();
    errors.value = registrationErrorsParser(registrationResult.errors);
    push({
      vCategory: 'landing_form',
      vAction: 'fail',
    });
  } else {
    isRegisterSuccess.value = true;

    const isCrypto = !!currencies.value.find(
      (cur) => cur.currency_code === playerInfo.profile_attributes.currency
    )?.crypto;

    const stag = String(route?.query?.stag || '');

    const token = generateAuthToken({
      login: playerInfo.email,
      password: playerInfo.password,
      stag,
      modal: isCrypto ? `deposit` : `signup`,
    });

    push({
      vCategory: 'landing_form',
      vAction: 'Success',
    });

    window.location.href = `https://${landingRedirectHost.value}?auth=${token}&stag=${stag}`;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(formHeaderTitle)), 1),
        _createElementVNode("label", {
          for: "email",
          class: _normalizeClass(["input-area", { 'input-area-error': _unref(errors).email || invalidEmail.value }])
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(regForm).email_title) + "*", 1),
          _createElementVNode("div", {
            class: _normalizeClass(["input-area-placeholder", {
              'input-area-placeholder-topover': _unref(form).email,
            }])
          }, _toDisplayString(_unref(regForm).email_title), 3),
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            id: "email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).email) = $event)),
            type: "email",
            name: "email",
            placeholder: _unref(regForm).email,
            class: "input-area-field-text"
          }, null, 8, _hoisted_7), [
            [_vModelText, _unref(form).email]
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(errors).email || invalidEmail.value), 1)
        ], 2),
        _createElementVNode("label", {
          for: "password",
          class: _normalizeClass(["input-area", { 'input-area-error': _unref(errors).password }])
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(regForm).password_title) + "*", 1),
          _createElementVNode("div", {
            class: _normalizeClass(["input-area-placeholder", { 'input-area-placeholder-topover': _unref(form).password }])
          }, _toDisplayString(_unref(regForm).password_title), 3),
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            id: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).password) = $event)),
            type: isShowPassword.value ? 'text' : 'password',
            name: "password",
            placeholder: _unref(regForm).password,
            class: "input-area-field-text"
          }, null, 8, _hoisted_11), [
            [_vModelDynamic, _unref(form).password]
          ]),
          _createElementVNode("img", {
            class: _normalizeClass(["modern-form__group-password-eye", { showPassword: isShowPassword.value }]),
            src: _imports_2,
            alt: "eye",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowPassword.value = !isShowPassword.value))
          }, null, 2),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(errors).password), 1)
        ], 2),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", {
            for: "currency",
            class: _normalizeClass(["input-area", { 'input-area-error': _unref(errors).currency }])
          }, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(regForm).currency_title), 1),
            (_unref(regForm).default_currency)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["input-area-placeholder", { 'input-area-placeholder-topover': _unref(form).currency }])
                }, _toDisplayString(_unref(regForm).currency_title), 3))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("select", {
              id: "currency",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).currency) = $event)),
              name: "currency",
              class: "input-area-field-select"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeCurrencies), (currency) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: currency.currency_code,
                  value: currency.currency_code,
                  class: "selector-option"
                }, _toDisplayString(currency.currency_code), 9, _hoisted_15))
              }), 128))
            ], 512), [
              [_vModelSelect, _unref(form).currency]
            ]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(errors).currency), 1)
          ], 2),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", {
              for: "terms",
              class: _normalizeClass(["input-area input-area-checkbox", { 'input-area-error': _unref(errors).terms_acceptance }])
            }, [
              _withDirectives(_createElementVNode("input", {
                id: "terms",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).terms_acceptance) = $event)),
                type: "checkbox",
                name: "terms",
                value: "terms",
                class: "terms-checkbox"
              }, null, 512), [
                [_vModelCheckbox, _unref(form).terms_acceptance]
              ]),
              _createElementVNode("span", {
                class: "input-area-checkbox__square",
                "data-checked": _unref(form).terms_acceptance
              }, null, 8, _hoisted_18),
              _createTextVNode(" " + _toDisplayString(_unref(regForm).terms_title) + " ", 1),
              _createElementVNode("a", {
                href: _unref(termsLink),
                class: "terms-link",
                prefetch: false
              }, _toDisplayString(_unref(regForm).terms_link_title), 9, _hoisted_19),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(errors).terms_acceptance), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("input", {
          type: "submit",
          value: _unref(registerTitle),
          class: "signup-button",
          onClick: _withModifiers(register, ["prevent"])
        }, null, 8, _hoisted_21),
        (__props.formText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(__props.formText), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          value: _unref(registerTitle),
          class: "modern-form__btn",
          onClick: _withModifiers(register, ["prevent"])
        }, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(registerTitle)), 1)
        ], 8, _hoisted_23)
      ]),
      _createElementVNode("span", _hoisted_25, [
        _createElementVNode("a", {
          href: _unref(signInLink),
          class: "terms-link",
          prefetch: false,
          onClick: _withModifiers(signIn, ["prevent"])
        }, _toDisplayString(_unref(regForm).have_account_question) + " " + _toDisplayString(_unref(regForm).signin_title), 9, _hoisted_26),
        _createElementVNode("span", _hoisted_27, [
          _createTextVNode(_toDisplayString(_unref(regForm).have_account_question) + " ", 1),
          _createElementVNode("a", {
            href: _unref(signInLink),
            class: "terms-link",
            prefetch: false,
            onClick: _withModifiers(signIn, ["prevent"])
          }, _toDisplayString(_unref(regForm).signin_title), 9, _hoisted_28)
        ])
      ]),
      _hoisted_29
    ]),
    _createVNode(LoaderPromoPopup, {
      data: __props.promoLoader,
      "is-success": isRegisterSuccess.value
    }, null, 8, ["data", "is-success"])
  ]))
}
}

})